// extracted by mini-css-extract-plugin
export default {"container":"R2Component_container__ZON+k","label":"R2Component_label__8Ipng","question":"R2Component_question__Kf6BV"};